<template>
  <div class="modal fade" :id="option.id" role="dialog">
    <div class="modal-dialog choose-modal">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title text-left">{{option.title}}</h4>
        </div>
        <div class="modal-body text-left">
          <div class="text-left" v-for="adjust in adjustList" v-if="adjust.active">
            <h5 class="p-l-10">{{adjust.name}}
              <button class="pull-right btn btn-default text-15 btn-add-product btn-success" style="top: -12px" @click="choseOption(adjust, true)">全選</button>
              <button class="pull-right btn btn-default text-15 btn-add-product btn-danger m-r-10" style="top: -12px" @click="choseOption(adjust, false)">全取消</button>
            </h5>
            <button class="btn btn-default btn-choose-element" v-for="option in adjust.child_list" @click="clickElement(option, adjust)" :class="{active: option.active}"
            >
              {{option.name}}<br>
              <div class="text-remark"><small>&nbsp;{{option.remark}}&nbsp;</small></div>
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" v-if="!hideCancel">取消</button>
          <button class="btn btn-primary" data-dismiss="modal">
            確定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    option: {
      type: Object,
      required: true
    },
    adjustList: Array,
    hideCancel: Boolean
  },
  data () {
    return {
      selected: 0,
      inputValue: '',
      elementRemark: ''
    }
  },
  methods: {
    showRemark (elem) {
      this.elementRemark = elem.remark
    },
    hideRemark () {
      this.elementRemark = ''
    },
    trigger (event) {
      this.$emit('trigger', event)
    },
    clickElement (option, adjust) {
      option.active = !option.active
    },
    clearAll () {
      for (var i = 0; i < this.elementList.length; i++) {
        this.elementList[i].active = false
      }
    },
    choseOption (adjust, isChose) {
      var oList = adjust.child_list
      for (var i = 0; i < oList.length; i++) {
        oList[i].active = isChose
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ChooseOptionModal.vue?ed7b7bf0